import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import '../components/settings/cp-channel-settings.js';
import '../components/settings/cp-agent-settings.js';
import '../components/settings/cp-user-profile-editor.js';
import '../components/settings/cp-sync-settings.js';
import '../components/settings/cp-external-agent-settings.js';
import '../components/settings/cp-betterstack-settings.js';
import '../components/settings/cp-google-accounts-settings.js';
import '../components/settings/cp-google-ads-settings.js';
import '../components/settings/cp-google-analytics-settings.js';
import '../components/settings/cp-instagram-settings.js';
import '../components/settings/cp-meta-accounts-settings.js';
import { navigateTo } from '../services/router.js';
import '../components/shared/cp-page-subnav.js';

const SYSTEM_TABS = [
  { label: 'Settings', path: '/settings' },
  { label: 'Agenten', path: '/agents' },
  { label: 'Team & Skills', path: '/team' },
  { label: 'Agent-Skills', path: '/skills' },
  { label: 'Routinen', path: '/cron' },
  { label: 'Monitoring', path: '/monitoring' },
];

@customElement('cp-page-settings')
export class CpPageSettings extends LitElement {
  createRenderRoot() { return this; }

  render() {
    return html`
      <div class="cp-page cp-page-settings">
        <cp-page-subnav .tabs=${SYSTEM_TABS} activePath="/settings"></cp-page-subnav>
        <h1 class="cp-page__title">Settings</h1>

        <section class="cp-page-settings__section">
          <cp-lifeplan-settings></cp-lifeplan-settings>
        </section>

        <section class="cp-page-settings__section">
          <cp-category-settings></cp-category-settings>
        </section>

        <section class="cp-page-settings__section">
          <cp-voice-settings></cp-voice-settings>
        </section>

        <section class="cp-page-settings__section">
          <cp-google-accounts-settings></cp-google-accounts-settings>
        </section>

        <section class="cp-page-settings__section">
          <cp-google-ads-settings></cp-google-ads-settings>
        </section>

        <section class="cp-page-settings__section">
          <cp-google-analytics-settings></cp-google-analytics-settings>
        </section>

        <section class="cp-page-settings__section">
          <cp-meta-accounts-settings></cp-meta-accounts-settings>
        </section>

        <section class="cp-page-settings__section">
          <cp-instagram-settings></cp-instagram-settings>
        </section>

        <section class="cp-page-settings__section">
          <cp-channel-settings></cp-channel-settings>
        </section>

        <section class="cp-page-settings__section">
          <div class="cp-page-settings__agent-link">
            <h3 class="cp-page-settings__section-title">Agent-Persoenlichkeit</h3>
            <p class="cp-page-settings__section-hint">Die Persoenlichkeits-Einstellungen findest du jetzt auf der Agenten-Seite.</p>
            <button class="cp-page-settings__link-btn" @click=${() => navigateTo('/agents')}>Zur Agenten-Seite</button>
          </div>
        </section>

        <section class="cp-page-settings__section">
          <cp-user-profile-editor></cp-user-profile-editor>
        </section>

        <section class="cp-page-settings__section">
          <cp-agent-settings></cp-agent-settings>
        </section>

        <section class="cp-page-settings__section">
          <cp-external-agent-settings></cp-external-agent-settings>
        </section>

        <section class="cp-page-settings__section">
          <cp-betterstack-settings></cp-betterstack-settings>
        </section>

        <section class="cp-page-settings__section">
          <cp-sync-settings></cp-sync-settings>
        </section>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cp-page-settings': CpPageSettings;
  }
}
